import { render, staticRenderFns } from "./zyzDetail.vue?vue&type=template&id=0c47a4ee&scoped=true&"
import script from "./zyzDetail.vue?vue&type=script&lang=js&"
export * from "./zyzDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47a4ee",
  null
  
)

export default component.exports